import { render } from "./EndpointOption.vue?vue&type=template&id=0ecc788f&scoped=true&ts=true"
import script from "./EndpointOption.vue?vue&type=script&lang=ts"
export * from "./EndpointOption.vue?vue&type=script&lang=ts"

import "./EndpointOption.vue?vue&type=style&index=0&id=0ecc788f&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0ecc788f"]])

export default __exports__